import useSeamlyChat from 'ui/hooks/use-seamly-chat'

const SeamlyChat = ({ children }) => {
  useSeamlyChat()
  return <>{children}</>
}

export default SeamlyChat
